import PortfolioPage from './pages/PortfolioPage';
import './pages/PortfolioPage.css';

function App() {
  return (
    <div className="appShell">
      <PortfolioPage />
    </div>
  );
}

export default App;
